"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessIconWithTooltip = void 0;
var CheckCircle_1 = require("@mui/icons-material/CheckCircle");
var React = require("react");
var IconWithTooltip_1 = require("./IconWithTooltip");
var style = {
    color: '#008000',
    display: 'inline-block',
};
var SuccessIconWithTooltip = function (_a) {
    var placement = _a.placement, text = _a.text;
    return (React.createElement("div", { style: style },
        React.createElement(IconWithTooltip_1.default, { Icon: CheckCircle_1.default, text: text, placement: placement })));
};
exports.SuccessIconWithTooltip = SuccessIconWithTooltip;
//# sourceMappingURL=SuccessIconWithTooltip.js.map